import { TChangePreferencesReq } from "@sharedTypes/req.type";
import { TChangePreferencesRes } from "@sharedTypes/res.type";
import missingParametersError from "api/Error";
import axios from "axios";

export async function ChangePreferences(firstName: string, lastName: string) {
  const apiUrl = "/auth/changepreferences";

  const body: TChangePreferencesReq = {
    firstName,
    lastName,
  };

  for (const [key, param] of Object.entries(body)) {
    if (param === undefined) throw missingParametersError(key);
  }

  const data: TChangePreferencesRes = await axios
    .post(apiUrl, body)
    .then((res) => res.data)
    .catch((err) => {
      console.log(err);
      throw err.response.data;
    });
  return data;
}
